module.exports = __webpack_public_path__ + "al.no1.84cdf439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/al.no1.jpg
// module id = Q9Ws
// module chunks = 0